import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Link from "next/link";
import { NextSeo } from "next-seo";
import Image from "next/image";

import Header from "../../Header";
import Footer from "../../Footer";
import SideMenu from "../../SideMenu";
import { NavigationBar } from "../../../src/components/atoms";
import { Constants, Values } from "../../../src/config";
import { useRouter } from "next/router";

const GuideYearWorld = (props) => {
  const { t } = useTranslation();
  const router = useRouter();
  const { listData, yearSelected } = props;
  const [sideMenuShow, setSideMenuShow] = useState(false);
  const [sideMenuHeaderShow, setSideMenuHeaderShow] = useState(false);
  const [isMobileVersion, setIsMobileVersion] = useState(false);

  const continents = Constants.CONTINENTS;
  const showListData = listData
    .filter((i) => i.region != null)
    .map((item) => {
      return continents.find((i) => i.title === item.region);
    });

  useEffect(() => {
    setIsMobileVersion(Values.deviceWidth < 640);
  }, [Values.deviceWidth]);

  return (
    <div>
      <NextSeo
        noindex={false}
        nofollow={false}
        title={`World Guides - ${process.env.NEXT_PUBLIC_APP_NAME}`}
        description={`Discover ${
          process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
            ? "clubs"
            : process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
            ? "rooftops"
            : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
            ? "cocktail bars"
            : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
            ? "spas"
            : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
            ? "beach clubs"
            : process.env.NEXT_PUBLIC_APP_NAME == "Festicket"
            ? "festivals"
            : "clubs"
        } around the World with our guides.`}
        canonical={`https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}/guides/${yearSelected}`}
        openGraph={{
          type: "website",
          locale: "en_EN",
          url: `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}/guides/${yearSelected}`,
          title: `World Guides - ${process.env.NEXT_PUBLIC_APP_NAME}`,
          description: `Discover ${
            process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
              ? "clubs"
              : process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
              ? "rooftops"
              : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
              ? "cocktail bars"
              : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
              ? "spas"
              : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
              ? "beach clubs"
              : process.env.NEXT_PUBLIC_APP_NAME == "Festicket"
              ? "festivals"
              : "clubs"
          } around the World with our guides.`,
          images: [
            {
              url: `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}${process.env.NEXT_PUBLIC_BANNER_IMAGE}`,
              width: 1200,
              height: 630,
              alt: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
              type: "image/png",
            },
          ],
          siteName: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
        }}
      />
      <Header setSideMenuShow={setSideMenuShow} />

      <SideMenu
        sideMenuShow={sideMenuShow}
        setSideMenuShow={setSideMenuShow}
        sideMenuHeaderShow={sideMenuHeaderShow}
        setSideMenuHeaderShow={setSideMenuHeaderShow}
      />

      <div className="bg-black">
        <div
          className={`mx-auto relative ${
            isMobileVersion ? "px-[8px]" : "wrapper pt-[30px]"
          } pb-[130px]`}>
          <div className="max-w-1160px min-h-screen flex-1 mx-auto">
            <NavigationBar
              title="World"
              customStyle={isMobileVersion ? null : { marginTop: 0 }}
              isMobileVersion={isMobileVersion}
              onBackPressed={() => router.push("/guides")}
            />
            <div className="grid md:grid-cols-3 grid-cols-1 sm:gap-10 gap-5 px-[20px]">
              {showListData
                ?.sort((a, b) => a.order - b.order)
                ?.map((item, index) => (
                  <Link href={`/guides/${yearSelected}/${item?.slug}`}>
                    <a
                      className="bg-grayBackground flex flex-col justify-center items-center p-[75px] rounded-2xl cursor-pointer"
                      key={index}>
                      <div className="flex justify-center items-center w-[200px] h-[140px]">
                        <Image
                          src={item?.map}
                          width={item?.mapWidth}
                          height={item?.mapHeight}
                          alt={item?.title}
                          objectFit="contain"
                        />
                      </div>
                      <div className="flex flex-col justify-center items-center bg-grayText w-[240px] h-[50px] rounded-full text-white uppercase font-bold text-base text-center mt-[40px]">
                        {item?.title}
                      </div>
                    </a>
                  </Link>
                ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default GuideYearWorld;
